<template>
    <div>
        <nav class="navbar navbar-expand-md navbar-dark bg-primary sticky-top">
            <div class="container-fluid">
                <a class="navbar-brand" href="/">
                    <img
                        src="img/canon.svg"
                        alt
                        class="img-fluid"
                        style="max-width:140px;"
                        title="Canon"
                    />
                </a>
            </div>
        </nav>
        <main>
            <div class="container-fluid">
                <div class="row full-screen-height">
                    <div class="col-lg-4 col-md-6 p-4">
                        <br />
                        <br />
                        <h2 class="t-800 text-secondary">Canon</h2>
                        <p>Preencha os campos abaixo para consultar o status de seus reparos.</p>
                        <!-- <div class="alert alert-danger" v-if="error">{{ error }}</div> -->
                        <form method="POST" @submit.prevent="login" aria-label="Login">
                            <input
                                type="hidden"
                                name="_token"
                                value="MZbIl01JvIHWqmf2gUgBQoMl2RF0Bz25OWsAHcFh"
                            />
                            <transition name="error">
                                <div v-show="error" class="row">
                                    <div class="col-md-12">
                                        <div class="alert alert-danger">
                                            <i class="fas fa-exclamation-triangle"></i> O número de documento informado não possui registro.
                                        </div>
                                    </div>
                                </div>
                            </transition>
                            <div class="form-group row">
                                <select class="col-md-3 form-control" id="document_type" 
                                  v-model="document_type"
                                  v-bind:class="{ has_error: error }"
                                  v-on:change="changeDocumentType($event)">
                                  <option value="cpf">CPF</option>
                                  <option value="rg">RG</option>
                                </select>
                                <div class="col-md-9">
                                    <input
                                        id="document_number"
                                        type="text"
                                        class="form-control"
                                        v-model="document_number"
                                        value
                                        v-bind:class="{ has_error: error }"
                                        v-mask="dynamicType" 
                                        required
                                        autofocus
                                        placeholder="Número do documento"
                                    />
                                </div>
                            </div>
                            <div class="form-group row mb-0">
                                <div class="col-md-12">
                                    <button type="submit" class="btn btn-primary">Verificar</button>
                                    <!-- <a class="btn btn-link" href="#">Forgot Your Password?</a> -->
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-lg-8 col-md-6 bg-home"></div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Home",
  data() {
    return {
      dynamicType: '###.###.###-##',
      document_type: "cpf",
      document_number: "",
      error: false
    };
  },
  computed: {
  },
  events: {
    hideMessage: function() {
      this.error = false;
    }
  },
  methods: {
    changeDocumentType(event)
    {
       if (event.target.value === 'rg') {
         this.dynamicType = '##.###.###-##'
       }
       else {
         this.dynamicType = '###.###.###-##'
       }
    },
    login() {
      this.$store
        .dispatch("repairs/getByClient", {
          document_type: this.document_type,
          document_number: this.document_number
        })
        .then((response) => {
          
          if (response.data.code == 404 ) {
            this.error = true;
            return false;
          }

          this.$store.state.client_repairs = response.data;          
          this.$router.push("/status");
        })
        .catch(error => {
          this.error = true;
          setTimeout(
            function() {
              this.error = false;
            }.bind(this),
            3000
          );
        });
    }
  }
};
</script>
<style>
.error-enter-active,
.error-leave-active {
  transition: opacity 0.75s;
}
.error-enter,
.error-leave-to {
  opacity: 0;
}
.has_error {
  border: 1px solid #cc0000 !important;
}
</style>
